<template>
  <div :class="{ dropdown:true, open:open }">
      <span @click="open=!open">{{!selectedOption ? placeHolder : selectedOption.name || selectedOption }} <img src="/static/img/dropArrow.svg" alt="" /></span>
        <transition name="dropdown" :duration="{ enter: 800, leave: 20 }">
          <ul v-if="open && options && options.length>0">
            <li @click="updateOption( null, -1)" v-if="selectedItem!=null&&selectedItem!==-1">
              <em>{{ placeHolder }}</em>
            </li>
            <li v-for="(option,i) in options"
              :key="option.name"
              @click="updateOption(option,i)"
              v-if="i !== selectedItem">
              <em>{{ option.name || option }}</em>
            </li>
          </ul>

          <ul v-if="open && !options">
              <slot></slot>
          </ul>

          </transition>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: [Array, Object]
    },
    selected: {},
    placeHolder: String
  },
  data () {
    return {
      selectedOption: {},
      open: false,
      selectedItem: null
    }
  },
  created () {
    this.selectedOption = this.selected
    document.body.addEventListener('click', this.close)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.close)
  },
  watch: {
    open: function () {

    }
  },
  methods: {
    updateOption (option, i) {
      this.selectedItem = i
      this.selectedOption = option
      this.open = false
      this.$emit('option', option)
    },
    close (e) {
      if (!this.$el.contains(e.target)) this.open = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../sass/variables';

.dropdown {
  cursor:pointer;
  background-color:white;
  min-width:14em;
  box-sizing: border-box;
  display: flex;
  position: relative;
  width: 100%;
  height: 2.74em;
  @include for-size(phone-only) {
    height: 3.74em;
  }
  @include for-size(tablet-landscape-up) {
  min-width:13.6em;
  }
  @include for-size(desktop-up) {
  min-width:14em;
  }

  &.open {

    ul {

      max-height: 250px;
      overflow-y: auto;

      @include for-size(phone-only) {
        z-index: 2;
      }
      @include for-size(tablet-portrait-up) {
        z-index: 2;
      }
      @include for-size(tablet-landscape-up) {
        z-index: 0;
      }
      li {
        border-left: 1px solid #e0e0e0;
        border-right: 1px solid #e0e0e0;
        &:last-of-type{
          border-bottom: 1px solid #e0e0e0;
        }
        &:hover{
          border-left: 1px solid $red-fill;
          border-right: 1px solid $red-fill;
          &:last-of-type{
            border-bottom: 1px solid $red-fill;
          }
        }
      }
    }
    span{
      position: relative;
      border-left:1px solid #e0e0e0;
      border-right:1px solid #e0e0e0;

      img {
        transform:rotate(180deg);
      }
    }
  }

  span, em{
    width: 100%;
    font-family: $font-main;
    font-weight: 800;
    font-style: normal;
    text-decoration: none;
    padding: 1em;
    display: block;
    white-space: nowrap;
    //min-width:9em;
    text-align: left;
    font-size: 0.8em;
    box-sizing: border-box;
    border-left:1px solid white;
    border-right:1px solid white;
    @include for-size(phone-only) {
      padding: 1em;
      width: 100%;
      display: flex;
      justify-content: space-between;
      font-size:1.2em;
    }
    @include for-size(tablet-portrait-up) {
      font-size:1em;
      font-weight: 700;
    }
    @include for-size(tablet-landscape-up) {
      font-size: 1em;
      font-weight: 700;
    }
    @include for-size(desktop-up) {
      font-size: 0.8em;
    }
    &::selection { background: transparent; }

    &:hover{
      background-color:$red-fill;
      border-left:1px solid $red-fill;
      border-right:1px solid $red-fill;
      color:white;
      img{
        filter: invert(100%);
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          //filter: "DXImageTransform.Microsoft.Invert(1)";
          -ms-filter: "DXImageTransform.Microsoft.Invert(1)";
        }
      }
    }

    img {
      height:2em;
      transition: transform 0.2s ease;
      transform-origin: center;
      vertical-align: center;
      position: absolute;
      right: 7%;
      top: 22%;
      @include for-size(big-desktop-up) {
        height:2em;
      }
    }
  }
  em{
    text-align: left;
    @include for-size(phone-only) {
      padding-left:3em;
    }

  }
  ul {
    position: absolute;
    background-color:white;
    z-index: -1;
    top:100%;
    width:100%;
    left:0;
    box-sizing: border-box;
    .dropdown-enter-active, .dropdown-leave-active {
      z-index: 10;
    }
  }

}

.dropdown-enter, .dropdown-leave-to {
      transform: translateY(-3em);
      opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/elements/Dropdown.vue